/* eslint-disable import/prefer-default-export,import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import { SkeletonLoading as Skeleton } from 'assets/components';

export const GenericLoading = ({
  isFullScreen = true,
  customSize = 'pt-5 mt-5',
  customSpacing = null,
}) => (
  <div
    className={`d-flex justify-content-center align-items-center ${
      isFullScreen ? 'vh-100' : customSpacing
    } w-100`}>
    <div
      className="spinner-border text-primary"
      style={{ width: customSize || '', height: customSize || '' }}
      role="status"
    />
  </div>
);
GenericLoading.propTypes = {
  isFullScreen: PropTypes.bool,
  customSpacing: PropTypes.string,
  customSize: PropTypes.string,
};

export const WalletPopupItemPlaceholder = () => (
  <div className="ph-item align-items-center border-0 rounded-3">
    <div className="ph-col-2">
      <div className="ph-avatar" />
    </div>
    <div>
      <div className="ph-row">
        <div className="ph-col-4" />
        <div className="ph-col-8 empty" />
        <div className="ph-col-6" />
        <div className="ph-col-6 empty" />
      </div>
    </div>
    <div>
      <div className="ph-row">
        <div className="ph-col-6 ms-auto" />
      </div>
    </div>
  </div>
);

export const BalanceCardPlaceholder = () => (
  <div
    style={{ minHeight: '171px' }}
    className="d-flex flex-column ph-item mb-0 border-0 rounded-3 bg-lighter">
    <div className="d-flex flex-row justify-content-between h-100">
      <div className="d-flex flex-column">
        <Skeleton width={70} />
      </div>
    </div>
    <div className="d-flex justify-content-between h-100">
      <div className="d-flex flex-column">
        <Skeleton width={70} />
        <Skeleton width={140} />
      </div>
      <div className="d-flex flex-row justify-content-between align-items-center">
        <Skeleton width={70} />
        <Skeleton width={70} />
      </div>
    </div>
  </div>
);

export const CardPlaceholder = () => (
  <div
    style={{ minHeight: '204px' }}
    className="d-flex flex-column ph-item mb-0 border-0 rounded-3 py-3 px-4 bg-lighter">
    <div className="d-flex flex-row justify-content-between h-100">
      <div className="d-flex flex-column">
        <Skeleton width={70} />
      </div>
    </div>
    <div className="d-flex justify-content-between h-100">
      <div className="d-flex flex-column">
        <Skeleton width={70} />
        <Skeleton width={140} />
      </div>
      <div className="d-flex flex-row justify-content-between align-items-center">
        <Skeleton width={70} />
        <Skeleton width={140} />
      </div>
    </div>
  </div>
);

export const SettingButtonPlaceholder = () => (
  <div className="d-flex flex-column ph-item mb-0 border-0 rounded-3 py-3 px-4 bg-lighter">
    <div className="d-flex flex-row gap-3 align-items-center">
      <Skeleton circle width={30} height={30} />
      <div className="d-flex flex-column">
        <Skeleton width={70} />
        <Skeleton width={140} />
      </div>
    </div>
  </div>
);

export const TransactionItemPlaceholder = () => (
  <div className="ph-item mb-0 align-items-center border-0 rounded-3 py-3 px-4 bg-lighter">
    <div className="d-flex flex-row justify-content-between align-items-center mb-0">
      <div className="d-none d-md-flex flex-column">
        <Skeleton width={140} />
        <Skeleton width={70} />
      </div>
      <div className="d-none d-md-flex flex-column">
        <Skeleton width={140} />
        <Skeleton width={70} />
      </div>
      <div className="d-none d-md-flex flex-column">
        <Skeleton width={100} />
      </div>

      {/* MOBILE LAYOUT */}
      <div className="d-flex d-md-none flex-column">
        <Skeleton width={90} />
        <Skeleton width={35} />
      </div>
      <div className="d-flex d-md-none flex-column">
        <Skeleton width={90} />
        <Skeleton width={35} />
      </div>
      <div className="d-flex d-md-none flex-column">
        <Skeleton width={50} />
      </div>
    </div>
  </div>
);

export const DashboardTabSkeleton = () => (
  <div>
    <Skeleton width={70} />
  </div>
);

export const AccountItemPlaceholder = () => (
  <div className="ph-item align-items-center border-0 rounded-3 py-2 px-4 bg-lighter">
    <div className="d-flex flex-row justify-content-between align-items-center mb-0">
      <div className="d-none d-md-flex flex-column">
        <Skeleton circle width={50} height={50} />
      </div>
      <div className="d-none d-md-flex flex-column">
        <Skeleton width={140} />
        <Skeleton width={70} />
      </div>
      <div className="d-none d-md-flex flex-column">
        <Skeleton width={100} />
      </div>

      {/* MOBILE LAYOUT */}
      <div className="d-flex d-md-none flex-column">
        <Skeleton circle width={30} height={30} />
      </div>
      <div className="d-flex d-md-none flex-column">
        <Skeleton width={90} />
        <Skeleton width={35} />
      </div>
      <div className="d-flex d-md-none flex-column">
        <Skeleton width={50} />
      </div>
    </div>
  </div>
);

export const YieldItemPlaceholder = () => (
  <div className="ph-item align-items-center border-0 rounded-3 py-3 px-4 bg-lighter">
    <div>
      <div className="ph-row">
        <div className="ph-col-4" />
        <div className="ph-col-8 empty" />
        <div className="ph-col-6" />
        <div className="ph-col-6 empty" />
      </div>
    </div>
    <div>
      <div className="ph-row">
        <div className="ph-col-4" />
        <div className="ph-col-8 empty" />
        <div className="ph-col-6" />
        <div className="ph-col-6 empty" />
      </div>
    </div>
    <div>
      <div className="ph-row">
        <div className="ph-col-4" />
        <div className="ph-col-8 empty" />
        <div className="ph-col-6" />
        <div className="ph-col-6 empty" />
      </div>
    </div>
    <div>
      <div className="ph-row">
        <div className="ph-col-6 ms-auto" />
      </div>
    </div>
  </div>
);

export const EntryPlaceholder = () => (
  <div className="ph-item align-items-center border-0 p-3">
    <div>
      <div className="ph-row">
        <div className="ph-col-4" />
        <div className="ph-col-2 empty" />
        <div className="ph-col-2" />
      </div>
    </div>
  </div>
);

export const LoadingInputContent = ({ isLoading }) =>
  isLoading ? <div className="dot-flashing floating-left" /> : <></>;
LoadingInputContent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};
